<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Synthèse Portefeuille par Taille de Structure</strong>
      </b-card-header>
      <b-card-body>
        <table class="tab_synthese p-2" border="1px">
          <thead>
          <tr>
            <td class="prune-medium p-2"><b>Segment</b></td>
            <td class="prune-medium right p-2"><b>Nb SIREN</b></td>
            <td class="prune-medium right p-2"><i>%</i></td>
            <td class="prune-medium right p-2"><b>Effectif affilié</b></td>
            <td class="prune-medium right p-2"><i>%</i></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(element, key) in tabResult" :key="key">
            <td class="gris-clair p-2"><b>{{ element['Lib'] }}</b></td>
            <td class="gris-clair right p-2"><b>{{ element['Nb'] || '-' }}</b></td>
            <td class="gris-clair smaller right p-2">{{ formatTaux(element['Taux_nb']) }}</td>
            <td class="gris-clair right p-2">{{ element['Eff'] || '-' }}</td>
            <td class="gris-clair smaller right p-2">{{ formatTaux(element['Taux_Eff']) }}</td>
          </tr>
          <tr>
            <td class="prune-medium p-2"><b>Total Portefeuille</b></td>
            <td class="prune-medium right p-2"><b> {{ totalNumber || '-'}}</b></td>
            <td class="prune-medium right p-2"><b>100 %</b></td>
            <td class="prune-medium right p-2"><b>{{ totalEffectif || '-'}}</b></td>
            <td class="prune-medium right p-2"><b>100 %</b></td>
          </tr>
          </tbody>
        </table>
      </b-card-body>
    </b-card>
  </div>

</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "SyntheseStructure",
    data() {
      return {
        tabResult: [],
        totalEffectif: 0,
        totalNumber: 0,
        total: {
          'NbAutres': 0,
          'NbCadres': 0,
          'NbNonCadres': 0,
          'NbSIREN': 0,
          'NbTotal': 0,
          'Taux': 0,
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.downloadSyntheseStructure();
    },
    methods: {
      downloadSyntheseStructure() {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/extractions/synthese_structure')
          .then((response) => {
            // console.log('response : ', response.data.TabResult);
            this.$store.commit('IS_LOADING', false);
            this.tabResult = response.data.TabResult;
            this.totalEffectif = response.data.TotEff;
            this.totalNumber = response.data.TotNb;
          })
          .catch(error => {
            self.$store.commit('IS_LOADING', false);
            console.log(error);
          });
      },
      formatTaux(x) {
        return x !== 0 ? parseFloat(x).toFixed(1) + "%" : '0';
      }
    }
  }
</script>

<style scoped>

  .gris-clair {
    background-color: #EEEEEE;
    color: #000000;
  }

  .prune-medium {
    background-color: #C0504D;
    color: #FFFFFF;
  }


  .right {
    text-align: right;
  }

  .smaller {
    font-size: 0.9em;
  }

</style>

